// Shared surface presentation for the agent-monitoring views.

export const ALL_SURFACES = [
  'app',
  'excel',
  'teams',
  'appfab',
  'email',
  'sms',
  'whatsapp',
  'scheduled',
] as const;

export const SURFACE_COLORS: Record<string, string> = {
  app: '#8b5cf6', // violet (the Pelles platform)
  excel: '#22c55e', // green
  teams: '#3b82f6', // blue
  appfab: '#06b6d4', // cyan
  email: '#f59e0b', // amber
  sms: '#f97316', // orange
  whatsapp: '#25d366', // whatsapp green
  scheduled: '#a78bfa', // light violet
};

export const SURFACE_LABELS: Record<string, string> = {
  app: 'App',
  excel: 'Excel',
  teams: 'Teams',
  appfab: 'AppFab',
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  scheduled: 'Scheduled',
};

export function surfaceColor(surface: string | null | undefined): string {
  if (!surface) return '#94a3b8'; // gray for unknown
  return SURFACE_COLORS[surface] ?? '#94a3b8';
}

export function surfaceLabel(surface: string | null | undefined): string {
  if (!surface) return 'Unknown';
  return SURFACE_LABELS[surface] ?? surface;
}
